// Store 타입 정의
import { create } from "zustand";

type ColorStore = {
  color: string;
  setColor: (color: string) => void;
  colorId: number | null;
  setColorId: (colorId: number | null) => void;
  colorOptionKey: string;
  setColorOptionKey: (colorOptionKey: string) => void;
};

const selectedColorStore = (set: any): ColorStore => ({
  color: "",
  setColor: (color) => set({ color }),
  colorId: null,
  setColorId: (colorId) => set({ colorId }),
  colorOptionKey: "",
  setColorOptionKey: (colorOptionKey) => set({ colorOptionKey }),
});

const useSelectedColorStore = create(selectedColorStore);

export default useSelectedColorStore;
